import React, { useMemo, useRef, useState } from 'react';
import styles from './DynGroupSend.module.scss';
import { apiHolder as api, apis, getIn18Text } from 'api';
import { ReactComponent as IconWarn } from '@/images/icons/icon-warn.svg';
import { AddTagIcon } from '@web-mail/components/MailTagList/Icon';
import { Upload } from 'antd';
import classnames from 'classnames';
import IconCard from '@web-common/components/UI/IconCard';
import { Button, Checkbox, Modal, Table, Tooltip } from '@lingxi-common-component/sirius-ui';
import { useAppDispatch, useAppSelector, MailActions } from '@web-common/state/createStore';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const uploadAddr = mailApi.uploadDyncGroupSendFile();
const systemApi = api.api.getSystemApi();
const inElectron = systemApi.isElectron();
const CheckboxGroup = Checkbox.Group;
const EmailVar = '#{wmt_crm_邮箱}';
const DynGroupSend = props => {
    const { getEditor, dyncGroupSendReset } = props;
    const isDyncGroupSend = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.isDyncGroupSend; });
    const dynGroupSendStatus = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.dynGroupSendStatus; });
    const { id: currentMailId } = useAppSelector(state => state.mailReducer.currentMail);
    const dispatch = useAppDispatch();
    const [ckError, setCkError] = useState();
    const [templateData, setTemplateData] = useState([]);
    const files = useMemo(() => {
        return (dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.files) || [];
    }, [dynGroupSendStatus]);
    const upProgress = useMemo(() => {
        return (dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.upProgress) || '';
    }, [dynGroupSendStatus]);
    const step = useMemo(() => {
        return (dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.step) || 1;
    }, [dynGroupSendStatus]);
    const variableArr = useMemo(() => {
        return (dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.variableArr) || [];
    }, [dynGroupSendStatus]);
    const [checkedList, setCheckedList] = useState([]);
    const checkedListLen = useMemo(() => checkedList === null || checkedList === void 0 ? void 0 : checkedList.length, [checkedList]);
    const ckOptions = useMemo(() => {
        return variableArr.map(item => ({ label: item.key, value: item.var }));
    }, [variableArr]);
    const ckOptionsLen = useMemo(() => ckOptions === null || ckOptions === void 0 ? void 0 : ckOptions.length, [ckOptions === null || ckOptions === void 0 ? void 0 : ckOptions.length]);
    const checkAll = useMemo(() => checkedListLen === ckOptionsLen, [checkedListLen, ckOptionsLen]);
    const ifInsertTable = useMemo(() => {
        const { insertTypes } = dynGroupSendStatus || {};
        if (insertTypes && insertTypes.includes('table'))
            return true;
        return false;
    }, [dynGroupSendStatus]);
    const ifInsertText = useMemo(() => {
        const { insertTypes } = dynGroupSendStatus || {};
        if (insertTypes && insertTypes.includes('text'))
            return true;
        return false;
    }, [dynGroupSendStatus]);
    const setFiles = (files) => {
        const dealFiles = files.map(item => {
            const name = item.name.split('.');
            let suffix = '';
            if (name.length > 1)
                suffix = name.pop() || '';
            return Object.assign(Object.assign({}, item), { befName: name.join('.'), suffix });
        });
        dispatch(MailActions.doChangeDyncGroupSendStatus({ files: dealFiles }));
    };
    const setUpProgress = (progress) => {
        dispatch(MailActions.doChangeDyncGroupSendStatus({ upProgress: progress }));
    };
    const columns = [
        { title: '字段名', dataIndex: 'name', key: 'name' },
        { title: '字段值', dataIndex: 'val', key: 'val' },
    ];
    const uploadDis = useMemo(() => {
        if (upProgress === 'processing')
            return true;
        return false;
    }, [upProgress, files === null || files === void 0 ? void 0 : files.length]);
    const nextDis = useMemo(() => {
        if (!(files === null || files === void 0 ? void 0 : files.length))
            return true;
        if (upProgress !== 'success')
            return true;
        return false;
    }, [files === null || files === void 0 ? void 0 : files.length, upProgress]);
    const confirmDis = useMemo(() => {
        if (!dynGroupSendStatus)
            return true;
        const { insertTypes } = dynGroupSendStatus;
        if (!(insertTypes === null || insertTypes === void 0 ? void 0 : insertTypes.length) || !(checkedList === null || checkedList === void 0 ? void 0 : checkedList.length))
            return true;
        return false;
    }, [dynGroupSendStatus, checkedList === null || checkedList === void 0 ? void 0 : checkedList.length]);
    const uploadRef = useRef();
    const dataSource = useMemo(() => {
        const res = [];
        (variableArr || []).forEach(item => {
            if ((checkedList || []).includes(item.var)) {
                res.push({ name: item.key, val: item.value });
            }
        });
        return res;
    }, [variableArr, checkedList]);
    const cancel = () => {
        dispatch(MailActions.doChangeDyncGroupSendStatus({ showModal: false }));
        if (!isDyncGroupSend) {
            dispatch(MailActions.doClearDyncGroupSendStatus(null));
        }
    };
    const setReceivers = () => {
        let receivers = [];
        templateData.forEach(item => {
            const variableObj = (item.variables || []).find(item => item.var === EmailVar);
            if (variableObj) {
                try {
                    const mailStr = variableObj.value;
                    const mailArr = mailStr.split(',');
                    receivers = [...receivers, ...mailArr];
                }
                catch (error) {
                    console.error('modifyReceiver error', error);
                }
            }
        });
        const uniqueReceivers = [...new Set(receivers)];
        dispatch(MailActions.doModifyReceiver({ receiver: uniqueReceivers, receiverType: 'to' }));
        dispatch(MailActions.doModifyReceiver({ receiver: [], receiverType: 'cc' }));
        dispatch(MailActions.doModifyReceiver({ receiver: [], receiverType: 'bcc' }));
    };
    const setSubject = () => {
        const fileName = files[0].name;
        if (fileName) {
            const name = fileName.split('.');
            name.length > 1 && name.pop();
            dispatch(MailActions.doModifySubject(name.join('.')));
        }
    };
    const insertTable = (id) => {
        const editor = getEditor();
        if (editor) {
            const filteredVariableArr = variableArr.filter(item => checkedList.includes(item.var));
            const insertStr = `<div>&nbsp;</div>
      <div>
      <table id='${`tabel_${id}`}' border='1' style='border-color: rgb(204, 204, 204);border-collapse: collapse'>
          ${filteredVariableArr.reduce((prev, item) => {
                return (prev +
                    `<tr key=${item.key}>
              <td style='white-space: nowrap'>${item.key}</td>
              <td><span class='mce-lx-var mceNonEditable varSpan' style="white-space: pre-line;" contenteditable='false' data-var='${item.var}' data-var-show='[${item.key}]'>[${item.value || item.key}]</span></td>
            </tr>`);
            }, '')}
          </table></div>`;
            editor.insertContent(insertStr);
            editor.fire('setPlaceHolder', { value: '以下内容为表格文件中第一行数据作为展示参考，实际发送时会根据对应邮箱号发送对应信息，且发送时不包含此段文字' });
        }
    };
    const nextStep = () => {
        var _a;
        if (step === 1) {
            if (!(files === null || files === void 0 ? void 0 : files.length))
                return;
            dispatch(MailActions.doChangeDyncGroupSendStatus({
                insertTypes: ['table', 'text'],
                step: 2,
            }));
            setCheckedList(variableArr.map(item => item.var));
            return;
        }
        if (step === 2) {
            setCkError('');
            const { insertTypes } = dynGroupSendStatus || {};
            if (!(insertTypes === null || insertTypes === void 0 ? void 0 : insertTypes.length) || !(checkedList === null || checkedList === void 0 ? void 0 : checkedList.length)) {
                setCkError(getIn18Text('QINGZHISHAOXZYXNR'));
                return '';
            }
            dispatch(MailActions.doChangeContactVariables(templateData));
            dispatch(MailActions.doChangeDyncGroupSendStatus({ showModal: false, checkedList: checkedList }));
            setReceivers();
            setSubject();
            let dyncGroupSendId = '';
            if (!isDyncGroupSend) {
                dyncGroupSendId = `${currentMailId}${Math.random()}`;
                dispatch(MailActions.doChangeDyncGroupSend(true));
                dispatch(MailActions.doChangeDyncGroupSendStatus({ id: dyncGroupSendId }));
                if ((_a = dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.insertTypes) === null || _a === void 0 ? void 0 : _a.includes('table'))
                    insertTable(dyncGroupSendId);
            }
            else {
                dyncGroupSendId = (dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.id) || '';
                dyncGroupSendReset && dyncGroupSendReset();
                setTimeout(() => {
                    var _a;
                    if ((_a = dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.insertTypes) === null || _a === void 0 ? void 0 : _a.includes('table'))
                        insertTable(dyncGroupSendId);
                }, 800);
            }
        }
        return;
    };
    const prevStep = () => {
        dispatch(MailActions.doChangeDyncGroupSendStatus({ step: 1 }));
    };
    const addFile = () => {
        var _a;
        (_a = uploadRef === null || uploadRef === void 0 ? void 0 : uploadRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const downloadDemo = () => {
        const downUrl = mailApi.downDyncGroupSendFileDemo();
        console.log('downloadDemo', downUrl);
        if (!inElectron) {
            systemApi.webDownloadLink(downUrl);
        }
        else {
            systemApi.webDownloadLink(downUrl);
        }
    };
    const delAtt = (_index) => {
        const arr = [...files];
        arr.splice(_index, 1);
        setFiles(arr);
    };
    const beforeUpload = () => {
        setUpProgress('start');
        return true;
    };
    const getExtraData = (file) => {
        return { fileSize: file.size };
    };
    const onFileChange = (data) => {
        console.log('onFileChange', data);
        const { file: originFile } = data;
        const { name, size } = originFile;
        const file = { name, size, error: '' };
        const { error, percent, response, status } = originFile;
        if (error || status === 'error') {
            console.error('上传失败', error);
            file.error = getIn18Text('SHANGCHUANSHIBAI');
            setUpProgress('error');
            setFiles([file]);
            return;
        }
        if (percent === 100 && response) {
            const { code, data, message } = response;
            if (code !== 0 || !data) {
                console.error('上传失败', message || '');
                file.error = message || getIn18Text('SHANGCHUANSHIBAI');
                setUpProgress('error');
                setFiles([file]);
                return;
            }
            if (!(data === null || data === void 0 ? void 0 : data.length)) {
                console.error('内容为空', data);
                file.error = getIn18Text('NEIRONGWEIKONG');
                setUpProgress('error');
                setFiles([file]);
                return;
            }
            setFiles([file]);
            const fir = data[0];
            const { variables } = fir;
            setTemplateData(data);
            dispatch(MailActions.doChangeDyncGroupSendStatus({ variableArr: variables }));
            setUpProgress('success');
            return;
        }
        setFiles([file]);
        setUpProgress('processing');
    };
    const onCheckAllChange = (e) => {
        var _a;
        const checkAll = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.checked) || false;
        if (checkAll) {
            const allVals = variableArr.map(item => item.var);
            setCheckedList(allVals);
        }
        else {
            setCheckedList([]);
        }
    };
    const onCkGroupChange = (checkedList) => {
        setCheckedList(checkedList);
    };
    const onInsertTypeChange = (e, type) => {
        var _a;
        const checked = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.checked) || false;
        const { insertTypes } = dynGroupSendStatus || {};
        let types = [...(insertTypes || [])];
        if (checked) {
            if (!types.includes(type))
                types.push(type);
        }
        else {
            if (types.includes(type))
                types = types.filter(item => item !== type);
        }
        dispatch(MailActions.doChangeDyncGroupSendStatus({ insertTypes: types }));
    };
    return (React.createElement(Modal, { title: getIn18Text('DONGTAIQUNF'), wrapClassName: styles.dynGroupSendWrap, className: styles.dynGroupSendModal, width: 550, visible: dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.showModal, destroyOnClose: true, onCancel: cancel, footer: null },
        React.createElement("div", { className: styles.dynGroupSend },
            step === 1 && (React.createElement("div", { className: styles.step1 },
                React.createElement("p", { className: styles.support }, getIn18Text('ZHICHIYOUJCREGSDZDYB37')),
                React.createElement("p", { className: styles.intro }, getIn18Text('SHANGCHUANBIAOGXYBHY26')),
                React.createElement(Upload, { className: styles.uploadArea, accept: ".xlsx,.xls", data: getExtraData, action: uploadAddr, disabled: uploadDis, beforeUpload: beforeUpload, method: "post", showUploadList: false, withCredentials: true, onChange: onFileChange },
                    React.createElement("div", { ref: uploadRef, className: styles.activeArea }, getIn18Text('DIANJIHUOTZZZLSC'))),
                React.createElement("div", { className: styles.optArea },
                    React.createElement("span", { className: styles.addFile, onClick: addFile },
                        React.createElement(AddTagIcon, null),
                        getIn18Text('TIANJIAWENJ')),
                    React.createElement("span", { className: styles.downloadDemo, onClick: downloadDemo }, getIn18Text('XIAZAISHILBG'))),
                React.createElement("div", { className: styles.fileArea },
                    React.createElement("p", { className: styles.fileAreaTitle }, getIn18Text('YISHANGCHUANWJ')),
                    (files === null || files === void 0 ? void 0 : files.length) ? (React.createElement("div", { className: styles.fileList }, files.map((item, index) => (React.createElement("div", { key: index, className: styles.fileItem },
                        React.createElement("div", { className: styles.fileItemCont },
                            React.createElement("div", { className: styles.fileNameCont },
                                React.createElement("div", { className: styles.fileName },
                                    React.createElement("span", { className: styles.befName }, item === null || item === void 0 ? void 0 : item.befName),
                                    (item === null || item === void 0 ? void 0 : item.suffix) ? `.${item === null || item === void 0 ? void 0 : item.suffix}` : '',
                                    (item === null || item === void 0 ? void 0 : item.percent) ? ((item === null || item === void 0 ? void 0 : item.percent) < 100 ? `(${item === null || item === void 0 ? void 0 : item.percent}%)` : '') : '')),
                            React.createElement(IconCard, { className: styles.fileDel, type: "close", onClick: () => delAtt(index) })),
                        (item === null || item === void 0 ? void 0 : item.error) && React.createElement("div", { className: styles.fileError }, item === null || item === void 0 ? void 0 : item.error)))))) : (React.createElement("div", { className: styles.empty }, getIn18Text('ZANWU1')))),
                React.createElement("div", { className: styles.footer },
                    React.createElement(Button, { onClick: cancel }, getIn18Text('setting_system_switch_cancel')),
                    React.createElement(Button, { className: styles.blueBtn, disabled: nextDis, onClick: nextStep }, getIn18Text('XIAYIBU'))))),
            step === 2 && (React.createElement("div", { className: styles.step2 },
                React.createElement("p", { className: styles.support }, getIn18Text('ZHICHIYOUJCREGSDZDYB37')),
                React.createElement("div", { className: styles.fieldArea },
                    React.createElement("div", { className: styles.left },
                        React.createElement("p", { className: styles.title }, getIn18Text('QINGXUANZEXZYJZWZXSD2')),
                        React.createElement("div", { className: styles.cks },
                            React.createElement(Checkbox, { className: styles.ckAll, onChange: onCheckAllChange, checked: checkAll }, getIn18Text('QUANBU')),
                            React.createElement(CheckboxGroup, { className: styles.ckGroup, options: ckOptions, value: checkedList, onChange: onCkGroupChange }))),
                    React.createElement("div", { className: styles.right },
                        React.createElement("p", { className: styles.title }, getIn18Text('CHARUBIAOGNRYL')),
                        React.createElement(Table, { className: classnames(styles.previewTable, { [styles.empty]: !(dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) }), showHeader: false, pagination: false, bordered: true, dataSource: dataSource, columns: columns }))),
                React.createElement("p", { className: styles.selectedFields }, getIn18Text('YIXUANZEGBLGG90dzh4', { checkedListLen, ckOptionsLen })),
                React.createElement("div", { className: styles.contSelect },
                    React.createElement("p", null, getIn18Text('XUANZECHARQFYJZWDNR')),
                    React.createElement("div", null,
                        React.createElement(Checkbox, { checked: ifInsertTable, onChange: e => onInsertTypeChange(e, 'table') },
                            React.createElement("div", { className: styles.ckCont },
                                getIn18Text('BIAOGENEIR'),
                                React.createElement(Tooltip, { overlayClassName: styles.infoTooltip, arrowPointAtCenter: true, title: getIn18Text('ZAIYOUJIANZWZCRBGTQG23') },
                                    React.createElement(IconWarn, null)))),
                        React.createElement(Checkbox, { checked: ifInsertText, onChange: e => onInsertTypeChange(e, 'text') },
                            React.createElement("div", { className: styles.ckCont },
                                getIn18Text('WENZIBIANL'),
                                React.createElement(Tooltip, { overlayClassName: styles.infoTooltip, arrowPointAtCenter: true, title: getIn18Text('ZAIYOUJIANZWZCRKJWZG26') },
                                    React.createElement(IconWarn, null)))),
                        ckError && React.createElement("span", { className: styles.ckError }, ckError))),
                React.createElement("div", { className: styles.footer },
                    React.createElement(Button, { onClick: cancel }, getIn18Text('setting_system_switch_cancel')),
                    React.createElement(Button, { onClick: prevStep }, getIn18Text('SHANGYIBU')),
                    React.createElement(Button, { className: styles.blueBtn, disabled: confirmDis, onClick: nextStep }, getIn18Text('QUEDING'))))))));
};
export default DynGroupSend;
